/**
 * Whether a URL is a presigned object-storage link. Such a URL is a bearer
 * credential to the object it names, so no telemetry or replay plane may
 * record it. One definition for every browser capture path that filters it.
 */
const PRESIGNED_QUERY_PATTERN = /[?&]x-amz-(signature|credential)=/i;

export function isPresignedUrl(url: string): boolean {
  return PRESIGNED_QUERY_PATTERN.test(url);
}
